import ElectricBolt from "@mui/icons-material/ElectricBolt";
import { Divider, IconButton, Tooltip } from "@mui/material";
import { type FC, type MouseEvent, useCallback, useState } from "react";
import type { ChannelName } from "../../../../channels/types";
import { floatingToolbarStyles } from "../toolbar/floating-toolbar-styles";
import { useCoPilotToolbarContext } from "./co-pilot-toolbar-context";
import { useLexicalSelection } from "./use-lexical-selection";

export const CoPilotToolbarButton: FC<{
  channel: NonNullable<ChannelName>;
  format: "email" | "chat" | "sms";
  disabled?: boolean;
}> = ({ channel, format, disabled }) => {
  const selection = useLexicalSelection();
  const { openPanel } = useCoPilotToolbarContext();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      setOpen(false);
      const rect = e.currentTarget.getBoundingClientRect();
      openPanel({
        anchorPosition: { top: rect.bottom, left: rect.left },
        capturedSelection: selection,
        channel,
        format,
      });
    },
    [selection, channel, format, openPanel],
  );

  return (
    <>
      <Divider orientation="vertical" flexItem />
      <Tooltip
        title="CoPilot"
        disableFocusListener
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <IconButton
          data-analytics-id="lexical-co-pilot-floating-toolbar-button"
          tabIndex={-1}
          disabled={disabled}
          onClick={handleClick}
          sx={floatingToolbarStyles["floating"].button}
        >
          <ElectricBolt sx={floatingToolbarStyles["floating"].formatIcon} />
        </IconButton>
      </Tooltip>
    </>
  );
};
